const webIcons = [
  {
    font: 'angularjs',
    title: 'Angular 2+'
  },
  {
    font: 'react',
    title: 'ReactJS'
  },
  {
    font: 'sass',
    title: 'ReactJS',
    trailing: 'original',
  },
  {
    font: 'html5',
    title: 'HTML 5'
  },
  {
    font: 'css3',
    title: 'CSS'
  },
  {
    font: 'django',
    title: 'Django'
  },
  {
    font: 'nodejs',
    title: 'NodeJS'
  },
  {
    font: 'express-original',
    title: 'Express Middleware',
    trailing: 'wordmark'
  },
  {
    font: 'meteor',
    title: 'MeteorJS',
  },
  {
    font: 'amazonwebservices-plain',
    title: 'Amazon Web Services',
    trailing: 'wordmark'
  },
];



const languages = [
  {
    font: 'python',
    title: 'Python Flask/Django'
  },
  {
    font: 'csharp',
    title: 'C#'
  },
  {
    font: 'c',
    title: 'C'
  },
  {
    font: 'cplusplus',
    title: 'C++'
  },
  {
    font: 'javascript',
    title: 'Javascript'
  },
  {
    font: 'java',
    title: 'Java'
  },
  {
    font: 'go',
    title: 'Go'
  },
];

const mobileIcons = [
  {
    font: 'android',
    title: 'Android'
  },
  {
    font: 'swift',
    title: 'Swift'
  },
];

const databaseIcons = [
  {
    font: 'mysql',
    title: 'MySQL'
  },
  {
    font: 'postgresql',
    title: 'PostgreSQL'
  },
  {
    font: 'mongodb',
    title: 'MongoDB'
  },
];

export default {
  webIcons,
  mobileIcons,
  languages,
  databaseIcons
};
